<template>
  <v-container :fluid="true" class="page_container">
    <div class="info__title">
      <span class="info__title--text">
        ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ
      </span>
    </div>
    <div
        class="info__content"
    >
      <v-lazy
          v-if="!isLoadingInfos && items.length > 0"
          v-model="activeFaq"
          :options="{
              threshold: .5
          }"
          class="lazy-faq"
          transition="fade-transition"
      >
        <v-expansion-panels variant="accordion">
          <v-expansion-panel
              elevation="0"
              v-for="(item, index) in items"
              :key="`question_${index}`"
          >
            <v-expansion-panel-title hide-actions>
              <template v-slot:default="props">
                <v-icon :size="`${$vuetify.display.xs ? '15' : '25'}`" :class="`${!props.expanded ? 'expand-icon' : 'collapse-icon'}`">$custom_arrow_sm_down</v-icon>
                {{ item.question }}
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <span v-html="item.full_answer"></span>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-lazy>
      <div v-else-if="!isLoadingInfos && items.length === 0">
        <NoData/>
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "Infos",
  components: { NoData, FulfillingSquareSpinner },
  data () {
    return {
      activeFaq: false,
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      items: 'personal_account/infos/getInfos',
      isLoadingInfos: 'personal_account/infos/isLoadingInfos',
    }),
  },
  methods: {
    ...mapActions({
      loadInfos: 'personal_account/infos/loadInfos',
    }),
    loadData (url = undefined) {
      this.loadInfos({
        url: url,
        // urlAppend: (url) => {
        //   return this.addPageParameter(this.addSizeParameter(url))
        // },
        finalizer: (data, url) => {
          // this.setCurrentLoadUrl(url)
        },
        catcher: () => {}
      })
    },
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.info__title {
  display: flex;
  justify-content: space-between;
}

.info__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.info__content {
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 50px;

  flex-direction: column;
  margin: auto;
  display: flex;
  z-index: 2;
}

.v-expansion-panel {
  border-radius: 0 !important;
  background-color: transparent;
}

.v-expansion-panel-title {
  height: 79px;
  border-bottom: none;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #313743;
  justify-content: flex-start;
  @media (max-width: 600px) {
    font-size: 15px;
    line-height: 20px;
  }
}

.v-expansion-panel-text {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-align: start;
  padding-left: 55px;
  color: #313743;
  @media (max-width: 600px) {
    font-size: 15px;
    line-height: 20px;
  }
}

.v-expansion-panel:not(:first-child)::after {
  border-color: #313743 !important;
}

.v-expansion-panel:last-child {
  border-bottom: 1px solid #313743;
}

.expand-icon {
  transition: all .3s;
  margin-right: 30px;
  margin-left: 0;
}
.collapse-icon {
  transform: rotate(180deg);
  transition: all .3s;
  margin-right: 30px;
}

@media screen and (max-width: 768px) {
  .info__title {
    margin-top: 20px;
  }

  .info__content {
    padding: 20px;
  }

  .info__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .v-expansion-panel-title {
    font-size: 16px;
    line-height: 20px;
    padding: 0;
  }

  .info__title_row {
    &--second {
      margin: 10px 0;
      padding-left: 40px;
    }
  }

  .expand-icon {
    margin-right: 20px;
  }

  .collapse-icon {
    margin-right: 20px;
  }

  .v-expansion-panel-text {
    font-size: 14px;
    line-height: 17px;
    padding-left: 16px;
  }
}

@media screen and (max-width: 369px) {
  .v-expansion-panel-title {
    font-size: 13px;
    line-height: 17px;
  }
}
</style>
